import { useCallback, useEffect, useState } from "react";

const PAGE_SIZE = 10;

// Hook dùng chung cho các tab trong chi tiết khách hàng: tải danh sách có phân trang theo customerId
export const useCustomerList = <T,>(
  customerId: number,
  fetcher: (params: Record<string, unknown>) => Promise<{ items: T[]; total: number }>,
  reloadKey = 0,
) => {
  const [page, setPage] = useState(1);
  const [items, setItems] = useState<T[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!customerId) return;
    setLoading(true);
    try {
      const res = await fetcher({ customerId, page, limit: PAGE_SIZE });
      setItems(res.items);
      setTotal(res.total);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, page]);

  useEffect(() => {
    load();
  }, [load, reloadKey]);

  const pagination =
    total > PAGE_SIZE
      ? { current: page, pageSize: PAGE_SIZE, total, showSizeChanger: false, onChange: setPage }
      : (false as const);

  return { items, total, loading, pagination, reload: load };
};
